import { render, staticRenderFns } from "./BriqDataTableActionMenu.vue?vue&type=template&id=2196cf08&scoped=true&lang=pug&"
import script from "./BriqDataTableActionMenu.vue?vue&type=script&lang=js&"
export * from "./BriqDataTableActionMenu.vue?vue&type=script&lang=js&"
import style0 from "./BriqDataTableActionMenu.vue?vue&type=style&index=0&id=2196cf08&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196cf08",
  null
  
)

export default component.exports